import { interopDefault } from '~/router/utils'
import { adminBlacklistRoutes } from '~/router/routes/car/admin/blacklist'
import { adminCategoriesRoutes } from '~/router/routes/car/admin/categories'
import { adminPopularityRoutes } from '~/router/routes/car/admin/popularity'
import { adminSearchRoutes } from '~/router/routes/car/admin/search'
import { adminSearchLogsRoutes } from '~/router/routes/car/admin/logs'
import { adminMissingMakeModelsRoutes } from './missing-makemodels'
import { adminAdvertisingRoutes } from '~/router/routes/car/admin/advertising'
import { adminWorkStatsRoute } from '~/router/routes/car/admin/work-stats'
import { adminSaleRequestsRoutes } from '~/router/routes/car/admin/sale-requests'
import { adminMarketplaceRoutes } from '~/router/routes/car/admin/marketplace'
import { adminAuditsRoute } from '~/router/routes/car/admin/audits'
import { adminBanksRoutes } from '~/router/routes/car/admin/banks'
import { adminReportsRoutes } from '~/router/routes/car/admin/reports'
import { adminInvoicesRoutes } from '~/router/routes/car/admin/invoices'
import { adminUsersRoutes } from '~/router/routes/car/admin/users'
import { adminIpsRoutes } from '~/router/routes/car/admin/ips'
import { adminShortUlrRoutes } from '~/router/routes/car/admin/short-url'
import { adminAnnouncementsRoutes } from '~/router/routes/car/admin/announcements'
import { adminTickets } from '~/router/routes/car/admin/tickets'
import { adminShortsRoutes } from '~/router/routes/car/admin/shorts'
import { adminInteractionsRoutes } from '~/router/routes/car/admin/interactions'
import { adminTranslationsRoutes } from '~/router/routes/car/admin/translations'
import { adminSearchEmailsRoutes } from '~/router/routes/car/admin/emails'
import { adminContentManagementToolsRoutes } from '~/router/routes/car/admin/content-management-tools'
import { adminTablesRoutes } from '~/router/routes/car/admin/tables'

export default [
  {
    name: '__admin',
    path: '/admin',
    component: () =>
      interopDefault(
        import(
          '~/pages/admin/index.vue' /* webpackChunkName: "pages-admin-index" */
        )
      )
  },
  ...adminBlacklistRoutes,
  ...adminCategoriesRoutes,
  ...adminAdvertisingRoutes,
  ...adminPopularityRoutes,
  ...adminSearchRoutes,
  ...adminSearchLogsRoutes,
  ...adminMissingMakeModelsRoutes,
  ...adminWorkStatsRoute,
  ...adminSaleRequestsRoutes,
  ...adminMarketplaceRoutes,
  ...adminAuditsRoute,
  ...adminBanksRoutes,
  ...adminReportsRoutes,
  ...adminInvoicesRoutes,
  ...adminUsersRoutes,
  ...adminIpsRoutes,
  ...adminShortUlrRoutes,
  ...adminAnnouncementsRoutes,
  ...adminTickets,
  ...adminShortsRoutes,
  ...adminInteractionsRoutes,
  ...adminTranslationsRoutes,
  ...adminSearchEmailsRoutes,
  ...adminContentManagementToolsRoutes,
  ...adminTablesRoutes
]
